import { store } from '../store/store.js';
import { config } from '../config.js';
import { saveAs } from 'file-saver';

//import router from '../router/index.js';
const _APIURL = config.APIURL;


export const apiService = {
  login,
  getNavbar,
  getCustomers,
  submitPreorder,
  getPortolio,
  getPartdata,
  getConfig,
  saveCart,
  getCart,
  deleteCart,
  getCustomerById
}

async function handleResponse(response) {
  const body = await response.text();
  const jsonBody = JSON.parse(body);

  if (!response.ok) {
    //just show error message and do not push back
    /*if (response.status == 401) {
      await store.dispatch('logout');
      if (router.currentRoute.fullPath !== '/login') {
        await router.push('/login');
      }
    }*/
    if (response.status == 401) {
      window.location.href = `${config.loginUrl}/login?returnUrl=${encodeURIComponent(window.location.origin)}`;
    }
    let error = new Error(jsonBody.message || '');
    error = jsonBody;
    throw error;
  } else {
    //OK
    return jsonBody;
  }
}
/*eslint-disable no-unused-vars */
async function handleFileResponse(response) {

  if (!response.ok) {
    await handleResponse(response);
    return;
  }

  const blob = await response.blob();
  const filename = response.headers.get('content-disposition')
    .split(';')
    .find(n => n.includes('filename='))
    .replace('filename=', '')
    .trim()
    .replace(/"/g, '');
  saveAs(blob, filename);
}

/*function getQueryString(obj) {
  let string = '';
  for (let key in obj) {
    if (obj[key]) {
      string += string ? `&${key}=${obj[key]}` : `?${key}=${obj[key]}`;
    }
  }

  return string;
}*/

/*
async function getLogons(user, machine, amount) {

  const request = {
    method: 'GET',
    headers: {
      //'Authorization': 'Bearer ' + store.state.token,
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.token}`
    }
  }
  const queryString = getQueryString({ user, machine });
  const response = await fetch(`${_APIURL}/it/v1/logon/latest/${amount}${queryString}`, request);
  const parsed = await handleResponse(response);
  return parsed;
}*/

async function login(username, password) {
  //let data = { username, password, strategy: 'ldap' };
  let data = { username, password };

  const request = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  }

  const response = await fetch(`${_APIURL}/order/login`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function getCustomers() {

  const request = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + store.state.token, },
  }

  const response = await fetch(`${_APIURL}/order/v1/customer/`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function getCustomerById(customerId) {

  const request = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + store.state.token, },
  }

  const response = await fetch(`${_APIURL}/order/v1/customer/${customerId}`, request);
  const parsed = await handleResponse(response);
  return parsed;

}

async function submitPreorder(preorder) {
  //let data = { username, password, strategy: 'ldap' };
  const request = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + store.state.token },
    body: JSON.stringify(preorder)
  }

  const response = await fetch(`${_APIURL}/order/v1/preorder/submit`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function saveCart(customerId, data) {
  //let data = { username, password, strategy: 'ldap' };
  const request = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + store.state.token },
    body: JSON.stringify(data)
  }

  const response = await fetch(`${_APIURL}/order/v1/preorder/cart/${customerId}`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function getCart(customerId, onlycheckexists) {
  //let data = { username, password, strategy: 'ldap' };
  const request = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + store.state.token },
    //body: JSON.stringify(data)
  }

  const response = await fetch(`${_APIURL}/order/v1/preorder/cart/${customerId}?onlycheckexists=${onlycheckexists}`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function deleteCart(customerId) {
  //let data = { username, password, strategy: 'ldap' };
  const request = {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + store.state.token },
    //body: JSON.stringify(data)
  }

  const response = await fetch(`${_APIURL}/order/v1/preorder/cart/${customerId}`, request);
  const parsed = await handleResponse(response);
  return parsed;
}


async function getPortolio(customerId) {
  //let data = { username, password, strategy: 'ldap' };
  const request = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + store.state.token },
  }

  const response = await fetch(`${_APIURL}/order/v1/preorder/portfolio/${customerId}`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function getConfig() {
  //let data = { username, password, strategy: 'ldap' };
  const request = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + store.state.token },
  }

  const response = await fetch(`${_APIURL}/order/v1/preorder/config`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function getPartdata(partIds, customerId) {
  //let data = { username, password, strategy: 'ldap' };
  const request = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + store.state.token },
    body: JSON.stringify(partIds)
  }

  const response = await fetch(`${_APIURL}/order/v1/parts/${customerId}?skipFreestock=true`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function getNavbar() {
  const request = {
    method: 'GET',
    /*headers: {
      //'Authorization': 'Bearer ' + store.state.token,
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.token}`
    }*/
  }
  const response = await fetch(`${_APIURL}/frontend/v1/navigation`, request);
  const parsed = await handleResponse(response);
  return parsed;
}